import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { PostHogProvider } from "@posthog/react";
import analytics from "./services/analytics";

analytics.initialize();

const rootElement = document.getElementById("root");
createRoot(rootElement).render(
  <React.StrictMode>
    <PostHogProvider client={analytics.client}>
      <App />
    </PostHogProvider>
  </React.StrictMode>
);
